<template>
    <CNav variant="tabs">
        <CNavItem
            v-for="item in links"
            :key="item.title"
            class="custom-pl-xs"
            :to="item.url"
            :active="isActive(item.url)"
            :disabled="isDisabled(item)"
        >
            {{ item.title }}
        </CNavItem>
    </CNav>
</template>

<script>
    export default {
        props: {
            links: {
                type: Array,
                default: () => [],
            },
        },

        methods: {
            isActive(linkPath) {
                const item = this.links.find(link => link.url === linkPath);
                if (item && item.exact) {
                    return this.$route.path === linkPath;
                }
                return this.$route.path.endsWith(linkPath);
            },
            isDisabled(item) {
                return item.disabled === true;
            }
        },
    };
</script>
<style scoped>
@media (max-width: 576px) {
  .custom-pl-xs a.nav-link {
        padding-left: 0.3rem;
        padding-right: 0.3rem;
    }
}
</style>
